import styles from './index.module.css'

import type { CellContext } from '@tanstack/react-table'
import React from 'react'

import type { Track } from 'types/track'

import { Badge, HoverCard, Text } from 'components/ds'

type Props = { info: CellContext<Track, unknown> }

const AppearsOnColumnInternal = ({ info }: Props) => {
  const count = info.row.original.playlists_count

  // Appears on is not available for MDS tracks (playlists_count is null).
  if (typeof count !== 'number') {
    return (
      <Text
        size="2"
        color="gray"
        className={styles.plainValue}
        data-testid="appears-on-cell"
      >
        —
      </Text>
    )
  }

  if (count === 0) {
    return (
      <Text
        size="2"
        color="gray"
        className={styles.plainValue}
        data-testid="appears-on-cell"
      >
        0
      </Text>
    )
  }

  return (
    <HoverCard.Root openDelay={300} closeDelay={100}>
      <HoverCard.Trigger>
        <Badge
          radius="full"
          className={styles.badge}
          data-testid="appears-on-cell"
        >
          {count}
        </Badge>
      </HoverCard.Trigger>
      <HoverCard.Content
        size="1"
        side="bottom"
        align="start"
        data-testid="appears-on-hover-card"
      >
        <Text size="1" weight="bold" color="gray">
          {`Appears on ${count} ${count === 1 ? 'playlist' : 'playlists'}`}
        </Text>
        {/* Playlist list lands in the next slice. */}
      </HoverCard.Content>
    </HoverCard.Root>
  )
}

export const AppearsOnColumn = React.memo(AppearsOnColumnInternal)

AppearsOnColumn.displayName = 'AppearsOnColumn'
